/**
 * Frontend Accordion Toggle Functionality
 */
document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.wp-block-faqmate-accordions .faq-accordion-item');

    accordionItems.forEach(item => {
        const header = item.querySelector('.faq-accordion-header');
        const button = item.querySelector('.faq-accordion-button');
        const collapse = item.querySelector('.faq-accordion-collapse');
        const icon = item.querySelector('.faq-accordion-icon');

        if (!header || !collapse) return;

        // Click handler for header/button
        const toggleAccordion = e => {
            // Prevent toggle if clicking inside the collapse content
            if (collapse.contains(e.target)) return;

            const isActive = item.classList.contains('active');

            if (isActive) {
                item.classList.remove('active');
                button?.classList.remove('active');
                collapse.classList.remove('active');
                collapse.style.maxHeight = '0px';
            } else {
                item.classList.add('active');
                button?.classList.add('active');
                collapse.classList.add('active');
                collapse.style.maxHeight = collapse.scrollHeight + 'px';
            }
        };

        // Add click event to header
        header.addEventListener('click', toggleAccordion);

        // Optional: Close other accordions when one opens (accordion mode)
        // Uncomment below if you want only one accordion open at a time
        /*
        header.addEventListener('click', function(e) {
            const parentAccordions = item.closest('.wp-block-faqmate-accordions');
            const allItems = parentAccordions.querySelectorAll('.faq-accordion-item');
            
            allItems.forEach(otherItem => {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                    const otherCollapse = otherItem.querySelector('.faq-accordion-collapse');
                    const otherButton = otherItem.querySelector('.faq-accordion-button');
                    
                    otherItem.classList.remove('active');
                    otherButton?.classList.remove('active');
                    otherCollapse?.classList.remove('active');
                    if (otherCollapse) otherCollapse.style.maxHeight = '0px';
                }
            });
            
            toggleAccordion(e);
        });
        */
    });

    // Handle dynamic height on window resize
    window.addEventListener('resize', function () {
        const activeCollapses = document.querySelectorAll('.faq-accordion-collapse.active');
        activeCollapses.forEach(collapse => {
            collapse.style.maxHeight = collapse.scrollHeight + 'px';
        });
    });
});
